// Copyright (c) 2024 by Audere

import { SxProps, Theme, darken, getLuminance } from "@mui/material";
import { blue, grey } from "@mui/material/colors";

export type StyleSheet = Record<string, SxProps<Theme>>;

export const createStyleSheet = (styles: StyleSheet) => styles;

export const logoColors = {
  continent: "#130026",
  circles: "#E82626",
  wires: "#C1C1C1",
};

export const globalStyles = createStyleSheet({
  pageContainerColumn: {
    display: "flex",
    flexDirection: "column",
    height: "100vh",
  },
  pageContainerRow: {
    display: "flex",
    flexDirection: "row",
    height: "100vh",
  },
  flexColumn: {
    display: "flex",
    flexDirection: "column",
  },
  flexRow: {
    display: "flex",
    flexDirection: "row",
  },
  selectedStyle: {
    backgroundColor: blue[50],
    border: `2px solid ${blue[500]}`,
    borderRadius: "8px",
  },
  unselectedStyle: {
    backgroundColor: "transparent",
    borderRadius: "8px",
    "&:hover": {
      outline: `1px solid ${grey[500]}`,
    },
  },
  logoThemeButtonSolid: {
    backgroundColor: logoColors.continent,
    color: "white",
  },
  logoThemeButtonOutlined: {
    borderColor: logoColors.continent,
    color: logoColors.continent,
  },
});

// Convert string to color
export function stringToColor(str: string): string {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = `#${Math.abs(hash).toString(16).substring(0, 6).padEnd(6, "0")}`;
  if (getLuminance(color) > 0.73) color = darken(color, 0.35);

  return color;
}
